import request from "./request";
import apis from "./apis";

const {
  allClass,
  allStudent,
  classInfo,
  allStudentByClass,
  changeClass,
  timePeriod,
} = apis.student;

const student = {
  getAllClass: () => {
    return request.get(allClass);
  },
  getAllStudent: (data?: Object) => {
    return request.get(allStudent, data);
  },
  createClassInfo: (data: Object) => {
    return request.post(classInfo, data);
  },
  updateClassInfo: (data: Object) => {
    return request.put(classInfo, data);
  },
  deleteClassInfo: (data: Object) => {
    return request.delete(classInfo, data);
  },
  getAllStudentByClass: (data: Object) => {
    return request.get(allStudentByClass, data);
  },
  updateStudentClass: (data: Object) => {
    return request.put(changeClass, data);
  },
  getTimePeriod: () => {
    return request.get(timePeriod);
  },
  createTimePeriod: (data: Object) => {
    return request.post(timePeriod, data);
  },
  updateTimePeriod: (data: Object) => {
    return request.put(timePeriod, data);
  },
  deleteTimePeriod: (data: Object) => {
    return request.delete(timePeriod, data);
  },
};

export default student;